<script lang="ts" setup>
import PageLink from '@/pages/hence/components/PageLink.vue'
import Newsletter from '@/pages/hence/components/Newsletter.vue'
import { Autoplay, Pagination, Controller, } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import { useArticleStore } from '@/stores'
import type { ResponseConfig, IArticleRecipeFilter, IArticleMagazine } from '@/utils/types'
import useSeo from './seo'

const route = useRoute()
const articleStore = useArticleStore()
await articleStore.fetchArticleCategories('projectCategories', {
  className: 'articleProject'
})
const res = ref<ResponseConfig>({
  code: 0,
  data: [] as Array<IArticleMagazine>,
  message: ''
})
const filter = ref<IArticleRecipeFilter>({
  page: 1,
  per_page: 9999,
  'category_ids[]': []
})

const magazines = computed(() => {
  return res.value.data.map((item: IArticleMagazine) => {
    return {
      id: item.id,
      image: item.image,
      year: item.year,
      subtitle: item.subject,
      title: item.subtitle,
      text: item.description,
      link: item.url
    }
  })
})

const handleChangePage = async () => {
  const f = {
    ...filter.value,
    tmp: 1
  }
  res.value = await articleStore.fetchArticleMagazines(f)
}

handleChangePage()

const currentIndex = ref(1)

const bannerShow = ref(false)

const swiperSlideSelector = ref(null)
const swiperSlideSelectorMobile = ref(null)

// const syncSwipers = (currentSwiper) => {
//   const currentIndex = currentSwiper.realIndex;

//   if (swiperSlideSelector.value && swiperSlideSelector.value.realIndex !== currentIndex) {
//     swiperSlideSelector.value.slideTo(currentIndex, 1000);
//   }
// };

const onSwiper = (swiper: any) => {
  swiperSlideSelector.value = swiper;
}

const onSwiperMobile = (swiper: any) => {
  swiperSlideSelectorMobile.value = swiper;
}

const handelSwiperChange = (data: any) => {
  currentIndex.value = (data.realIndex || 0) + 1
}

const handleSlidePrev = () => {
  swiperSlideSelector.value.update();
  swiperSlideSelector.value.slidePrev()
}
const handleSlideNext = () => {
  swiperSlideSelector.value.update();
  swiperSlideSelector.value.slideNext()
}

onMounted(() => {
  bannerShow.value = true
})

useSeo()
</script>

<template>
  <section class="hence">
    <div class="hence__top">
      <div class="hence__top__logo">
        <Nimg src="./images/hence_logo.svg" format="" />
      </div>
      <h1 class="hence__top__title">歷期雜誌</h1>
      <PageLink />
    </div>
    <section class="magazine" :class="{ show: bannerShow }">
      <swiper :modules="[Autoplay, Pagination, Controller]" :slides-per-view="5" :autoplay="{
        delay: 3000
      }" :breakpoints="{
        321: {
          slidesPerView: 3,
          centeredSlides: true
        },
        768: {
          slidesPerView: 3
        },
        991: {
          slidesPerView: 5
        }
      }" :space-between="24" :speed="1000" :loop="true" class="magazine-list pc" @swiper="onSwiper"
        @slide-change="handelSwiperChange" :controller="{ control: swiperSlideSelectorMobile }">
        <swiper-slide v-for="(item, index) in magazines" :key="item.id">
          <nuxt-link :to="item.link" :alt="item.title" @mouseenter="swiperSlideSelector?.autoplay?.stop()"
            @mouseleave="swiperSlideSelector?.autoplay?.start()">
            <div class="magazine-list__box">
              <figure class="magazine-list__pic">
                <Nimg :src="item.image?.link" :alt="item.image?.alt" :title="item.image?.title" />
              </figure>
              <div class="magazine-list__content pc">
                <div class="magazine-list__top">
                  <div class="magazine-list__year">{{ item.year }}</div>
                  <div class="magazine-list__subtitle">{{ item.subtitle }}</div>
                </div>
                <div class="magazine-list__title">{{ item.title }}</div>
                <div class="magazine-list__text">{{ item.text }}</div>
                <div class="magazine-list__bottom">
                  <nuxt-link :to="item.link" class="magazine-list__link" :alt="item.title">閱讀本期雜誌
                    <span class="magazine-list__link__icon">
                      <svg-icon name="icon-reader" />
                    </span>
                  </nuxt-link>
                </div>
              </div>
            </div>
          </nuxt-link>
        </swiper-slide>
      </swiper>
      <div class="arrow brand4-1">
        <div class="arrow__prev" @click="handleSlidePrev">
          <svg-icon name="icon-arrow-right2" />
        </div>
        <div class="arrow__count">
          <div class="arrow__count__item">{{ currentIndex }}</div>
          <div class="arrow__count__item">{{ magazines.length }}</div>
        </div>
        <div class="arrow__next" @click="handleSlideNext">
          <svg-icon name="icon-arrow-right2" />
        </div>
      </div>
      <swiper :modules="[Autoplay, Pagination, Controller]" :autoplay="{
        delay: 3000
      }" :slides-per-view="1" :space-between="0" :speed="1000" :loop="true" class="magazine-list mobile"
        @swiper="onSwiperMobile" :controller="{ control: swiperSlideSelector }">
        <swiper-slide v-for="(item, index) in magazines" :key="index">
          <nuxt-link nuxt-link :to="item.link" :alt="item.title">
            <div class="magazine-list__box">
              <div class="magazine-list__content mobile">
                <div class="magazine-list__top">
                  <div class="magazine-list__year">{{ item.year }}</div>
                  <div class="magazine-list__subtitle">{{ item.subtitle }}</div>
                </div>
                <div class="magazine-list__title">{{ item.title }}</div>
                <div class="magazine-list__text">{{ item.text }}</div>
                <div class="magazine-list__bottom">
                  <nuxt-link :to="item.link" :alt="item.title" class="magazine-list__link">閱讀本期雜誌
                    <span class="magazine-list__link__icon">
                      <svg-icon name="icon-reader" />
                    </span>
                  </nuxt-link>
                </div>
              </div>
            </div>
          </nuxt-link>
        </swiper-slide>
      </swiper>
    </section>

    <Newsletter class="hence__full" />
  </section>
</template>

<style lang="scss" scoped>
.hence {
  @include max-media(767) {
    position: relative;
    z-index: 2;
    transform: translateY(toRem(100));
    margin-top: toRem(-100);
  }

  &__top {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__logo {
      width: 100%;
      max-width: toRem(276);

      img {
        display: block;
        width: 100%;
      }
    }

    &__title {
      margin-bottom: toRem(40);
      font-size: toRem(28);
      font-weight: 500;
      line-height: 1.3;
    }
  }

  &__full {
    margin-left: toRem(-24);
    margin-right: toRem(-24);
  }
}

.magazine-list {
  margin-left: toRem(-72);
  margin-right: toRem(-72);

  &.pc {
    .swiper-slide {
      transition: opacity 0.5s cubic-bezier(0.87, 0, 0.13, 1);

      &:not(:hover) {
        opacity: 0.6;
      }

      &:hover {
        opacity: 1;
      }
    }

    // .swiper-slide-active {
    //   opacity: 1 !important;
    //   margin-right: 50px !important;
    //   margin-left: 25px !important;
    //   .magazine-list {
    //     &__box {
    //       width: calc(100% + 50px);
    //       transform: translateX(-25px);
    //     }
    //   }
    // }
  }

  &.mobile {
    @include min-media(768) {
      display: none;
    }
  }

  .swiper-slide {
    width: 24%;

    &:hover {
      margin-right: 120px !important;

      .magazine-list {
        &__box {
          width: 100%;

          @include min-media(768) {
            width: calc(100% + 96px);
          }
        }

        &__content {
          opacity: 1;
          transform: translateY(0);
        }
      }
    }
  }

  &__pic {
    img {
      display: block;
      width: 100%;
    }
  }

  &__content {
    padding-top: toRem(12);

    &.pc {
      transform: translateY(24px);
      opacity: 0;
      transition: all 0.5s cubic-bezier(0.87, 0, 0.13, 1);

      @include max-media(767) {
        display: none;
      }
    }

    &.mobile {
      opacity: 1;
      padding: toRem(72);

      @include min-media(768) {
        display: none;
      }
    }
  }

  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: toRem(12);
  }

  &__year {
    font-family: $font-TextaAlt;
    font-size: toRem(60);
    font-weight: 500;
    line-height: 0.8;
    letter-spacing: toRem(-1.2);
    color: $color-brand-4_1;

    @include max-media(480) {
      font-size: toRem(48);
    }
  }

  &__subtitle {
    font-size: toRem(20);
    font-weight: 500;
    line-height: 1.4;
    margin-left: toRem(25);
  }

  &__title {
    padding-bottom: toRem(12);
    font-size: toRem(16);
    font-weight: 900;
    line-height: 1.6;
  }

  &__text {
    padding-bottom: toRem(12);
    font-size: toRem(16);
    line-height: 1.45;
  }

  &__link {
    display: flex;
    align-items: center;
    font-size: toRem(16);
    font-weight: 700;
    color: $color-gray-1;
    line-height: 1.6;

    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: toRem(14);
      width: toRem(40);
      height: toRem(40);
      border: 1px solid $color-gray-line;
      border-radius: 50%;

      svg {
        width: toRem(16);
        height: toRem(16);
        color: $color-brand-4_1;
      }
    }
  }
}

.magazine {
  position: relative;
  margin-bottom: toRem(100);

  @include max-media(480) {
    margin-bottom: toRem(25);
  }

  .arrow {
    display: flex;
    align-items: center;

    @include max-media(480) {
      padding-top: toRem(50);
    }

    &__count {
      display: flex;
      padding: 0 toRem(24);
      font-family: $font-TextaAlt;
      font-size: toRem(20);
      line-height: 0.8;
      color: $color-gray-1;

      &__item {
        &:first-child {
          &::after {
            content: '|';
            display: inline-block;
            padding-left: toRem(8);
            padding-right: toRem(8);
          }
        }
      }
    }
  }
}
</style>
